import React, { useContext, useMemo, useState } from 'react';
import { IconButton, TextField } from '@mui/material';
import { CloseRounded } from '@mui/icons-material/';
import AppTitle from '@/components/common/title';
import s from './styles.module.scss';
import { AudioSurah } from '@/infrastructure/class/audio-surah';
import Link from 'next/link';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { ReadSurahSlugsContext } from '@/infrastructure/context/read-surah-slugs-context';
import { getAudioSurahPath } from '@/infrastructure/functions/get-audio-surah-path';

interface IAudioSurahSelectorFormProps {
  currentSurah: AudioSurah;
  surahs: AudioSurah[];
  reciterSlug?: string;
  onClose?: () => void;
}

const AudioSurahSelectorForm: React.FC<IAudioSurahSelectorFormProps> = (
  props
) => {
  const { currentSurah, surahs, reciterSlug, onClose = () => {} } = props;
  const { getSurahSlugByNumber } = useContext(ReadSurahSlugsContext);

  const [surahSearch, setSurahSearch] = useState<string>('');

  const filteredSurah = useMemo<AudioSurah[]>(() => {
    if (!surahSearch.trim()) return surahs;
    return surahs.filter((surah) => {
      const { titleEn, titleAr } = surah;
      if (
        titleEn.toLowerCase().includes(surahSearch) ||
        titleAr.toLowerCase().includes(surahSearch)
      ) {
        return true;
      }
      return false;
    });
  }, [surahSearch, surahs]);

  const { t: tButtons } = useTranslation('buttons');

  const linkClassNames = (surah: AudioSurah) =>
    classNames(s['item'], {
      [s['active']]: currentSurah.slug === surah.slug,
    });

  return (
    <div className={s['form']}>
      <div className={s['header']}>
        <AppTitle className={s['title']} title={currentSurah.titleEn} />
        <IconButton onClick={onClose}>
          <CloseRounded />
        </IconButton>
      </div>
      <div className={s['body']}>
        <TextField
          variant="standard"
          size="small"
          placeholder={tButtons('searchSurahs')}
          onChange={(e) => setSurahSearch(e.target.value)}
        />
        <ul className={s['list']}>
          {filteredSurah.map((surah) => (
            <li key={surah.number}>
              <Link
                className={linkClassNames(surah)}
                href={getAudioSurahPath({
                  reciterSlug: reciterSlug ?? surah.reciter?.slug,
                  surahNumber: surah.number,
                  getSurahSlugByNumber,
                })}
                title={`${surah.number} ${surah.titleEn} - سورة ${surah.titleAr}`}
                onClick={onClose}
              >
                {`${surah.number} ${surah.titleEn} - سورة ${surah.titleAr}`}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AudioSurahSelectorForm;
